import styled from 'styled-components/macro';
import { FocusableParent } from 'components/navigation';
import scaleSize from 'utils/scale-size';

export const StyledTitleBlock = styled.div`
  margin-top: ${scaleSize(45)}px;
  margin-bottom: ${scaleSize(34)}px;
  margin-left: ${scaleSize(160)}px;
`;

export const StyledTitle = styled.div<{ left?: boolean }>`
  height: ${scaleSize(72)}px;
  font-size: ${scaleSize(48)}px;
  line-height: ${scaleSize(1.5, false)};
  letter-spacing: -0.33px;
  color: ${({ theme }) => theme.defaultColor};
  text-align: ${({ left }) => (left ? 'left' : 'center')};
`;

export const StyledParentalItemsWrapper = styled(FocusableParent)`
  margin-top: ${scaleSize(220)}px;
  margin-left: ${scaleSize(160)}px;
`;

export const StyledBlock = styled.div`
  width: ${scaleSize(680)}px;
  margin: ${scaleSize(34)}px auto;
`;
